<template>
  <div class="page">
    <van-icon class="icon" name="arrow-left" color="#181616" size="20" @click="back" />
    <img class="article_bg" src="../../../../assets/house/property/article_bg.png" alt="">
  </div>
</template>

<script>
  export default {
    methods: {
      back() {
        this.$router.go(-1);
      },
    }
  }
</script>

<style lang="less" scoped>
  .page {
    position: relative;
  }

  .article_bg {
    width: 100%;
  }

  .icon {
    position: absolute;
    top: 44px;
    left: 16px;
  }
</style>